import { TableContainer, Table, TableBody, TableRow, TableCell } from '@material-ui/core';
import React from 'react';
import { InfoLinks } from 'store/url-builder';
import { DialogWrapper, DialogWrapperType } from '../../../shared/dialog/index';

export interface LinksDialogProps {
 open: boolean;
 onClose(): void;
 data: InfoLinks[];
}

export const LinksDialog = ({ data, open, onClose }: LinksDialogProps) => (
 <DialogWrapper type={DialogWrapperType.DEFAULT} title='Card links' open={open} onClose={onClose}>
  <TableContainer>
   <Table size="small" >
    {/* <TableHead>
          <TableRow>
            <TableCell>Dessert (100g serving)</TableCell>
            <TableCell align="right">Calories</TableCell>
            <TableCell align="right">Fat&nbsp;(g)</TableCell>
            <TableCell align="right">Carbs&nbsp;(g)</TableCell>
            <TableCell align="right">Protein&nbsp;(g)</TableCell>
          </TableRow>
        </TableHead> */}
    <TableBody>
     {data.map((row, idx) => (
      <TableRow key={idx}>
       {/* <TableCell>
        <b>{row.title}</b>
       </TableCell> */}
       <TableCell><a target="_new" href={row.url.startsWith("http")?row.url:"http://"+row.url}>{row.title}</a></TableCell>
      </TableRow>
     ))}
    </TableBody>
   </Table>
  </TableContainer>
 </DialogWrapper>
);
